import SaveProfileButton from 'profile/components/save_profile_button';
import { submit } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { PROFILE_FORM } from 'profile/constants';

export function mapStateToProps({ profile: { view } }) {
  return {
    isSaving: view.isLoading || view.isSaving,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    saveProfile: partial(submit, PROFILE_FORM)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveProfileButton);
